import './css/main.css'; // main css file
import './js/main.js'; // main js file


document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('msi-INT')) {
        import('./js/arrowsToBtns.js')
            .then(module => {
                module.default?.();
            }).catch(err => {});
    }
});